import CarouselSliderAreaComum from "./CarouselSliderAreaComum";

export default CarouselSliderAreaComum;
